import styled from 'styled-components';

import { ContextDialog, Layer } from '@dreryk/react-components';

export const StyledContextDialog = styled(ContextDialog)`
   padding: 24px;
   z-index: ${Layer.AlwaysTop};
`;
StyledContextDialog.displayName = 'StyledContextDialog';
